import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-max",
  templateUrl: "./field-set-max.component.html",
  styles: [],
})
export class FieldSetMaxComponent {
  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
